<template>
    <div>
      <component :is="loginComponent" />
    </div>
</template>

<script>
import NormalLogin from './components/NormalLogin.vue'
import CustomLogin from './components/CustomLogin.vue'

export default {
  components: {
    NormalLogin,
    CustomLogin
  },
  data() {
    return {
      loginComponent: null
    }
  },
  mounted() {
    this.determineLoginComponent()
  },
  methods: {
    determineLoginComponent() {
      const domain = window.location.hostname
      if (['localhost', 'app.enviame.io', 'stage.app.enviame.io'].includes(domain)) {
        this.loginComponent = 'NormalLogin'
      } else {
        this.loginComponent = 'CustomLogin'
      }
    }
  }
}
</script>